export default __webpack_public_path__ + "f97c1d9da9994b5fdd0e4377c9318764.svg";